export default __webpack_public_path__ + "static/jonathan-3df64f31f9b1667590ebfc8e45ce8c5e.jpg";